import React from 'react';
import {default as benefit1} from '../../../images/benefit1.svg';
import {default as benefit2} from '../../../images/benefit2.svg';
import {default as benefit3} from '../../../images/benefit3.svg';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import useEcoAllianceMemberBenefit from '../../hooks/useEcoAllianceMemberBenefit';
import './EcoAllianceBenefits.scss';
import downloadEcoAllianceQrCertification from "../../../utils/downloadEcoAllianceQrCertification";

const benefitsJson = [
  {
    img : benefit1,
    heading : 'Contribute to Reforestation',
    subheading : 'Plant a tree with every order you make and contribute to global reforestation!'
  },
  {
    img : benefit2,
    heading : 'Get access to Rewards',
    subheading : 'Gain access to promotions and member perks, like the opportunity to be featured on our online publication The Wrap.'
  },
  {
    img : benefit3,
    heading : 'Be Part of a Community',
    subheading : 'Join like-minded businesses who are making a difference together. Keep up to date with community initiatives and news!'
  }
]

const EcoAllianceBenefits = () => {

  const benefits = useEcoAllianceMemberBenefit();
  const { allContentfulEcoAllianceMemberBenenfit : {edges : MemberBenefits}} = benefits;

  return (
    <div className="noissue__eco-alliance__benefits">
      <div className="heading">
        Eco-Alliance Member Benefits
      </div>
      <div className="subheading">
        Become a member of our alliance and join a worldwide community
      </div>
      <div className="benefit-container" >
        {
          MemberBenefits.map((item, idx) => {
            return <div key={`eco-allinace-benefit-${idx}`} className="benefit-item">
              <CommunityImg className="benefit-img" src={item.node.benefitImage.file.url} alt={item.node.benefitHeading} />
              <div className="benefit-content">
                <div className="benefit-heading">
                  {item.node.benefitHeading}
                </div>
                <div className="benefit-subheading">
                  {item.node.benefitSubHeading}
                </div>
              </div>
            </div>
          })
        }
      </div>
      <div className="snake-game"  />
      <button className="benefit-button" onClick={downloadEcoAllianceQrCertification}> Download Eco-A QR </button>
    </div>
  )
}

export default EcoAllianceBenefits;